import { render, staticRenderFns } from "./ButtonCustom.vue?vue&type=template&id=28827abe&"
import script from "./ButtonCustom.vue?vue&type=script&lang=ts&"
export * from "./ButtonCustom.vue?vue&type=script&lang=ts&"
import style0 from "./ButtonCustom.vue?vue&type=style&index=0&id=28827abe&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports